import { Box, Typography } from "@mui/material";

type Props = {
  title: string;
};

const Header = ({ title }: Props) => {
  return (
    <Box padding="20px 10px 16px 10px">
      <Typography
        variant="header"
        fontSize="32px"
        fontWeight="600"
        data-testid="customer-management-title"
      >
        {title}
      </Typography>
    </Box>
  );
};

export default Header;
